var map = {
	"./pages/admin/admin.module": [
		"./src/app/pages/admin/admin.module.ts",
		"default~pages-admin-admin-module~pages-company-company-module~pages-persons-persons-module",
		"pages-admin-admin-module"
	],
	"./pages/company/company.module": [
		"./src/app/pages/company/company.module.ts",
		"default~pages-admin-admin-module~pages-company-company-module~pages-persons-persons-module",
		"common",
		"pages-company-company-module"
	],
	"./pages/persons/persons.module": [
		"./src/app/pages/persons/persons.module.ts",
		"default~pages-admin-admin-module~pages-company-company-module~pages-persons-persons-module",
		"common",
		"pages-persons-persons-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;